import Upload from './src/main.vue'

export default Upload
